import { InternalError } from './internal.error';

/**
 * The backend could not resolve the typed location to a real city, so the job was refused
 * (ff-rest `cityStateNotFound`, forwarded by ats-project as a 422). Retrying the same
 * text will never succeed; the user has to pick another location.
 */
export class LocationNotFoundError extends InternalError {
  public readonly location: string;

  constructor(location: string, status?: number | null) {
    super('Location could not be resolved to a city', {
      status,
      data: { location },
    });
    this.location = location;
  }
}
